export default "__VITE_ASSET__CtoZa2iY__"